/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

/**
 * Headline metric cards for the Monitor Sessions page (028 US1 + US3) on the shared
 * au-card design system. Total Sessions and Total Users, each with a
 * period-over-period delta (text + icon, never colour alone). Total Users also
 * carries its feature-024 participation rate and the "Subscribed" count.
 */
const ICONS = { up: '▲', down: '▼', flat: '→', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

const Delta = ({ delta }) => {
  if (!delta || !delta.direction) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new'
    ? `${ICONS.new} New`
    : direction === 'flat'
      ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(pct)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="ms-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="ms-delta__lbl">{label}</span>
    </span>
  );
};

const n = (v) => Number(v || 0).toLocaleString();

const MonitorSessionSummaryCards = ({
  totalSessions = 0,
  totalUsers = 0,
  totalUserBase = 0,
  subscribedUserCount = 0,
  deltas = {},
}) => (
  <div className="au-cards" data-testid="ms-summary">
    <div className="au-card">
      <span className="au-card__label">Total Sessions</span>
      <span className="au-card__value tnum">{n(totalSessions)}</span>
      <Delta delta={deltas.total_sessions} />
    </div>
    <div className="au-card">
      <span className="au-card__label">Total Users</span>
      <span className="au-card__value tnum">{n(totalUsers)}</span>
      <ParticipationRate className="au-card__sub" count={totalUsers} total={totalUserBase} />
      <span className="au-card__sub" data-testid="ms-subscribed">Subscribed: {n(subscribedUserCount)}</span>
      <Delta delta={deltas.total_users} />
    </div>
  </div>
);

export default MonitorSessionSummaryCards;
